export const FOOTER_TYPES = {
  DEFAULT: "Default",
  NONE: "None",
  SIMPLE: "Simple Footer",
  REALLYSIMPLE: "Really Simple Footer",
};

export const HEADER_TYPES = {
  DEFAULT: "Default",
  NONE: "None",
  SIMPLE: "Simple Header",
  REALLYSIMPLE: "Really Simple Header",
  SECONDARY: "Secondary Header",
};
